import { postApi } from "./api_instance";

export const counterBidPostApi = async (formData, dispatch) => {
  try {
    return await postApi({
      apiUrl: "/projects/api/myBids/counter-bid",
      sendToken: true,
      dispatch,
      data: formData,
    });
  } catch (error) {
    throw error;
  }
};
